import { aiInspectionManagerPath, tenantKnowledgeBasePath } from '@routes';
import { translate } from '@utils/i18n';
const NAMESPACE = 'features.ai_configure_menu';
/**
 * Canonical destinations for the AI Configure menu. Both the Inspection
 * Assistant Review screen (IP-14857) and the IP Assistant chat widget
 * (IP-14858) link to the same two settings pages.
 *
 * Resolved via js-routes `@routes` helpers — never literal path strings — so the
 * URLs stay locale-safe and in sync with `config/routes.rb`. The real routes have
 * NO `/settings/` prefix (IP-14858 widget-404 fix); the helpers encode that.
 */
export function aiConfigureDestinations() {
    return {
        assistantSettings: aiInspectionManagerPath(),
        rulesAndKnowledge: tenantKnowledgeBasePath()
    };
}
/**
 * Builds the localized menu items for a given surface. The review screen labels
 * the first row "Inspection Assistant Settings"; the chat widget uses the
 * shorter "IP Assistant Settings" (matching the widget's existing title copy).
 * The AI Rules & Knowledge row is identical on both.
 */
export function buildAiConfigureItems(surface) {
    const settingsLabelKey = surface === 'widget' ? 'ip_assistant_settings' : 'inspection_assistant_settings';
    const destinations = aiConfigureDestinations();
    return [
        {
            key: 'assistant-settings',
            label: translate(settingsLabelKey, { namespace: NAMESPACE }),
            href: destinations.assistantSettings
        },
        {
            key: 'rules-and-knowledge',
            label: translate('rules_and_knowledge', { namespace: NAMESPACE }),
            href: destinations.rulesAndKnowledge
        }
    ];
}
